import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import config from "../../environment";

export default function useAnalytics() {
    const location = useLocation();

    useEffect(() => {
        const trackingId = config.googleAnalyticsId;
        const isDev = config.localDevMode;

        ReactGA.initialize(trackingId, {
            testMode: isDev
        });
    }, []);

    useEffect(() => {
        const currentPath = location.pathname + location.search;
        ReactGA.send({ hitType: "pageview", page: currentPath });
    }, [location]);
}